<div class="m-t-20">
  <h4 class="section-header m-b-10 m-t-30">
    Manage Learn Content
    <span class="section-header-link" (click)="collapsed = !collapsed">
      {{ collapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
      <fa-icon [icon]="collapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
    </span>
  </h4>
  <div class="m-b-20">
    @if (!loading && !hasMetadata && !collapsed) {
      This product has no learn content associated with it yet.
    } @else if (!loading && hasMetadata && !collapsed) {
      Associated learn content with this product.
    }
  </div>
  @if (!collapsed) {
    <myp-segmented-bar
      (selected)="switchLearnContentSection($event)"
      [options]="[
        {
          name: 'Videos',
          id: 'videos',
          selected: true,
        },
        {
          name: 'Lessons',
          id: 'lessons',
        },
      ]"
    ></myp-segmented-bar>

    <div class="m-t-20">
      @if (snapshot.pimSpecs?.productNo) {
        <div class="form-group">
          <strong>
            <myp-switch
              [active]="associateWithProductLine"
              label="Associate with Product Line (Recommended)"
              [labelToRight]="true"
              (toggle)="associateWithProductLine = !associateWithProductLine"
            ></myp-switch>
          </strong>
          <div class="text-muted t-12 m-t-10">
            Toggling this on associates the selected learn content with the product line for this product, not just this individual SKU. It will apply to all SKUs in the product line.
          </div>
        </div>
      }
      <myp-learn-content-picker
        [type]="pickerType"
        [excludeIds]="pickerExcludeIds"
        [hint]="pickerHint"
        [placeholder]="pickerPlaceholder"
        [disabled]="loading"
        [admin]="true"
        [showDone]="true"
        (added)="onPickerAdded($event)"
      ></myp-learn-content-picker>
    </div>

    @if (loading) {
      <fa-icon icon="spinner" animation="spin"></fa-icon>
      Loading learn content...
    }
    @if (!loading && hasMetadata && !collapsed) {
      @if (displayedSection == "videos" && snapshot.metadata?.videos?.length) {
        <h3 class="fui-heading-font t-20">Associated Videos</h3>
        @for (videoId of snapshot.metadata.videos; track videoId) {
          @if (contentService.videosById[videoId]) {
            <!-- @if (isFromProductLine(videoId, 'video')) {
              <div class="d-flex align-items-center">
                <myp-video-list-item class="flex-grow-1" [admin]="true" [video]="contentService.videosById[videoId]"></myp-video-list-item>
                <span class="text-muted t-12 m-l-10" style="white-space: nowrap;">via Product Line</span>
              </div>
            } @else {
             <myp-video-list-item [admin]="true" (removed)="removeVideo(videoId)" [showRemove]="true" [video]="contentService.videosById[videoId]"></myp-video-list-item>
            } -->
            <myp-video-list-item [admin]="true" (removed)="removeVideo(videoId)" [showRemove]="true" [video]="contentService.videosById[videoId]"></myp-video-list-item>
          }
        }
      }
      @if (displayedSection == "lessons" && snapshot.metadata?.lessons?.length) {
        <h3 class="fui-heading-font t-20">Associated Lessons</h3>
        @for (lessonId of snapshot.metadata.lessons; track lessonId) {
          @if (contentService.lessonMap[lessonId]) {
            <!-- @if (isFromProductLine(lessonId, 'lesson')) {
              <div class="d-flex align-items-center">
                <myp-learn-list-item class="flex-grow-1" [large]="false" [item]="contentService.lessonMap[lessonId]"></myp-learn-list-item>
                <span class="text-muted t-12 m-l-10" style="white-space: nowrap;">via Product Line</span>
              </div>
            } @else {
              <myp-learn-list-item [large]="false" (removed)="removeLesson(lessonId)" [showRemove]="true" [item]="contentService.lessonMap[lessonId]"></myp-learn-list-item>
            } -->
            <myp-learn-list-item [large]="false" (removed)="removeLesson(lessonId)" [showRemove]="true" [item]="contentService.lessonMap[lessonId]"></myp-learn-list-item>
          }
        }
      }
    }
  }
</div>
